import cx from "classnames";
import React from "react";

import SellerProPlusBadge from "@/mk2/apps/bazaar/components/SellerProPlusBadge";
import { SellerEntity } from "@/mk2/apps/bazaar/schemas";
import {
    bazaarMyBazaarUrl,
    bazaarSellerReviewsFromBuyersUrl,
    bazaarSellerUrl,
} from "@/mk2/apps/bazaar/urls";
import { Dot } from "@/mk2/components/Dot";
import { Link } from "@/mk2/components/Link";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { url } from "@/mk2/helpers/urls";
import { interpolate } from "@/mk2/services/i18n";
import { counter_ENTRIES, counter_RATINGS } from "@/mk/autogenerated/translation";

import styles from "./GridItemFooter.mscss";

interface OwnProps {
    className?: string;
    seller: SellerEntity;
    isSeller?: boolean;
}

type Props = OwnProps;

const GridItemFooter: React.FunctionComponent<Props> = ({
    className,
    seller,
    isSeller = false,
}) => {
    const urlToSeller = isSeller
        ? url(bazaarMyBazaarUrl, { username: seller.username })
        : url(bazaarSellerUrl, { username: seller.username });

    return (
        <div className={cx(styles.GridItemFooter, className)}>
            <div className={styles.GridItemFooter__first}>
                <Link className={styles.GridItemFooter__username} to={urlToSeller}>
                    {seller.username}
                </Link>{" "}
                <SellerProPlusBadge
                    className={styles.GridItemFooter__badge}
                    user={seller.user}
                    isSeller={isSeller}
                    showPromo={false}
                />
                {seller.location && (
                    <>
                        <Dot spaces={1} />
                        {seller.location}
                    </>
                )}
                <div className={styles.GridItemFooter__mask} />
            </div>
            <div className={styles.GridItemFooter__second}>
                <Link
                    className={styles.GridItemFooter__productsCount}
                    to={url(bazaarSellerUrl, { username: seller.username })}
                >
                    {interpolate(counter_ENTRIES, {
                        counter: seller.productsCount,
                        count: seller.productsCount,
                    })}
                </Link>
                <Dot spaces={1} />
                <Link
                    className={styles.GridItemFooter__reviewsCount}
                    to={url(bazaarSellerReviewsFromBuyersUrl, { username: seller.username })}
                >
                    {interpolate(counter_RATINGS, {
                        counter: seller.reviewsCount,
                        count: seller.reviewsCount,
                    })}
                </Link>
                <div className={styles.GridItemFooter__mask} />
            </div>
        </div>
    );
};

GridItemFooter.displayName = "GridItemFooter";

export default React.memo<Props>(GridItemFooter);

interface PlaceholderOwnProps {
    className?: string;
}

let GridItemFooterPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ className }) => (
    <div className={cx(styles.GridItemFooter, className)}>
        <div className={styles.GridItemFooter__first}>
            <LoadingPlaceholder width={100} />
            <Dot spaces={1} />
            <LoadingPlaceholder width={65} />
            <div className={styles.GridItemFooter__mask} />
        </div>
        <div className={styles.GridItemFooter__second}>
            <LoadingPlaceholder width={70} />
            <Dot spaces={1} />
            <LoadingPlaceholder width={82} />
            <div className={styles.GridItemFooter__mask} />
        </div>
    </div>
);

GridItemFooterPlaceholder.displayName = "GridItemFooterPlaceholder";

GridItemFooterPlaceholder = React.memo<PlaceholderOwnProps>(GridItemFooterPlaceholder);

export { GridItemFooterPlaceholder };
